export enum PrescriptionStateEnum {
    Active = 'ACTIVE',
    OnHold = 'ON_HOLD',
    Done = 'DONE',
    Received = 'RECEIVED',
    Transferred = 'TRANSFERRED',
    v1Pending = 'V1PENDING',
    v1Rejected = 'V1REJECTED',
    Requested = 'REQUESTED',
    Initiated = 'INITIATED'
}

export enum StateTrigger {
    void = 'voidPrescription'
}